import SwipeableViewProps from './types';

// Swipeable View is available just on Android/iOS for now.
export default ({children}: SwipeableViewProps) => children;
